<template>
<div class="chapter">
<div class="inner_page">
<p class="noindentst" id="otherfm2"><a id="page_ix"></a><strong>No problem can be solved from the same<br/>level of consciousness that created it.</strong></p>
<p class="noindents1">— <strong><span class="small">ALBERT EINSTEIN</span></strong></p>
<p class="noindents"><strong>For peoples, generally, their story of the universe<br/>and the human role in the universe is their primary<br/>source of intelligibility and value. The deepest crises<br/>experienced by any society are those moments of<br/>change when the story becomes inadequate for<br/>meeting the survival demands of a present situation.</strong></p>
<p class="noindents1"><strong>— <span class="small">THOMAS BERRY</span></strong>, <strong><em>The Dream of the Earth</em></strong></p>
<p class="noindents"><strong>Let ours be a time remembered for the<br/>awakening of a new reverence for life.</strong></p>
<p class="noindents1"><strong>— <span class="small">THE EARTH CHARTER</span></strong><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// otherfm2.vue?319884f0